module.exports = __webpack_public_path__ + "img/rcp.4778d6cd.png";